module.exports = __webpack_public_path__ + "img/sns_share_kakao.403422ca.png";